<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="show"
      variant="transparent"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      no-wrap
    >
      <template #overlay>
        <div
          class="text-center"
          style="height: 120px; width: 70px"
        >
          <img
            src="../../../assets/images/gif/loader.gif"
            alt="udara360-logo"
            width="100%"
            height="100%"
          >
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'

export default {
  name: 'FullScreenSpinner',
  components: {
    BOverlay,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },

}
</script>
